<div class="p-2">
  <!-- Title -->
  <div class="row pb-2">
    <div class="col-10 h5 text-muted p-0">Settings</div>
    <div class="col-2 p-0">
      <button type="button" class="btn btn-secondary btn-sm text-white float-end fw-bold" title="Back" (click)="onBackClick()">
        <i-bs class="text-light" name="arrowLeft" width="22" height="22"></i-bs>
      </button>
    </div>
  </div>

  <div class="row bg-light p-2">
    <div class="col-12">

      <div class="row pt-2 pb-2 bg-white">
        <div class="col-12">

          <form [formGroup]="settingsForm" (ngSubmit)="onSaveSettings()">
            <!-- Point Cash Value -->
            <div class="row mt-4">
              <div class="col-3">
                <span class="text-muted fw-bold">
                  Point Cash Value
                  <i-bs
                    name="infoCircle"
                    class="text-primary"
                    tooltip="Enter dollar value of one point."
                    placement="top">
                  </i-bs>
                </span>
              </div>
              <div class="col-3">
                <div class="input-group">
                  <span class="input-group-text">$</span>
                  <input type="text" class="form-control" formControlName="point_cash_value" id="point_cash_value" placeholder="E.g. 1" maxlength="3">
                </div>
              </div>
              <div class="col-6">
                <div class="spinner-border spinner-border-sm text-primary mt-2" role="status" *ngIf="settingsLoader">
                  <span class="sr-only"></span>
                </div>
                <span class="text-danger error-message" *ngIf="(settingsForm.controls.point_cash_value.dirty || settingsForm.controls.point_cash_value.touched) && settingsForm.controls.point_cash_value.invalid">
                  Invalid point cash value
                </span>
              </div>
            </div>

            <hr class="text-black-50 mt-4">

            <!-- Save button -->
            <div class="row mt-3 mb-3">
              <div class="col-6">
              </div>
              <div class="col-6 text-end">
                <button type="submit" class="btn btn-secondary text-white" title="Save">
                  Save
                  <div class="spinner-border spinner-border-sm" role="status" *ngIf="buttonLoader"></div>
                </button>
              </div>
            </div>

          </form>

        </div>
      </div>

    </div>
  </div>
</div>

